import { BaseReducer } from '@hobs/utils/baseReducer';
import {
  GETNOTIFICATIONS,
  RESETNOTIFICATIONS
} from '@hobs/constants/notifications';

class Notifications extends BaseReducer {
  static defaultState = {
    data: [],
    totalCount: 0
  };

  constructor() {
    super(Notifications.defaultState);

    this.actionMap = {
      [GETNOTIFICATIONS.SUCCESS]: this.appendNotificationData,
      [RESETNOTIFICATIONS.SUCCESS]: this.resetData
    };
  }

  appendNotificationData = (state, action) => {
    let data = [...state.data, ...action.response.value];

    // removes duplicates in case new notification gets added
    data = data.filter((value, index, self) => {
      return (
        index ===
        self.findIndex(
          t =>
            t.ServiceRequestId === value.ServiceRequestId &&
            t.IndicationDescription == value.IndicationDescription
        )
      );
    });

    return Object.assign({}, state, {
      data: data,
      totalCount: action.response['@odata.count']
    });
  };

  resetData = state => {
    return Object.assign({}, state, {
      data: [],
      totalCount: 0
    });
  };
}
export default new Notifications().reducer;
